import {lazy} from 'react';
import GenericFallbackSuspense from '../../../ui/GenericFallback/GenericFallbackSuspense';

const AdyenV2ActionOverlayBody = lazy(
  () => import('./AdyenV2ActionOverlayBody'/* webpackChunkName: 'AdyenV2ActionOverlayBody' */),
);

export default function AdyenV2ActionOverlayLazyLoader(props) {
  return (
    <GenericFallbackSuspense>
      <AdyenV2ActionOverlayBody {...props} />
    </GenericFallbackSuspense>
  );
}
